/* eslint-disable import/no-named-default */
import { default as UserPilotUtil } from 'userpilot';

import { userpilotProcessQueue } from './process-queue';

const { Userpilot } = UserPilotUtil;

const isEnabled = ({
  NEB_ENV: { USERPILOT_API_KEY, USERPILOT_ENABLED } = {},
}) => USERPILOT_ENABLED === 'true' && USERPILOT_API_KEY !== '';

function initialize() {
  if (!isEnabled(window)) {
    return;
  }

  const {
    NEB_ENV: { USERPILOT_API_KEY },
  } = window;

  Userpilot.initialize(USERPILOT_API_KEY);
}

function identifyUser({
  email,
  firstName,
  lastName,
  practiceName,
  role,
  salesforceId,
  tenantId,
  tier,
  addOns,
}) {
  if (!isEnabled(window)) {
    return;
  }

  const params = {
    email,
    ...((firstName || lastName) && {
      name: [firstName, lastName].filter(Boolean).join(' '),
    }),
    ...(tenantId && {
      company: {
        id: tenantId,
        name: practiceName,
        salesforceId,
        tier,
        addOns,
      },
      role,
    }),
  };

  userpilotProcessQueue.add(Userpilot.identify, email, params);
}

function logout() {
  if (!isEnabled(window)) {
    return;
  }

  userpilotProcessQueue.add(Userpilot.clean);
}

function track(eventName, params) {
  if (!isEnabled(window)) {
    return;
  }

  userpilotProcessQueue.add(Userpilot.track, eventName, params);
}

function trigger(surveyCode) {
  if (!isEnabled(window)) {
    return;
  }

  Userpilot.trigger(surveyCode);
}

function reload() {
  if (!isEnabled(window)) {
    return;
  }

  Userpilot.reload();
}

export { initialize, identifyUser, logout, trigger, track, reload };
